<template>
  <div v-if="hasLoaded" :class="`api-sport api-sport-${siteName}`">
    <component
      :is="comp"
      :matchId="matchId"
      :apiLiveUrl="apiLiveUrl"
      :isFetchOdd="isFetchOdd"
    ></component>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  defineAsyncComponent,
  ref,
  nextTick,
} from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";

// this demonstrate dynamic frontend app using a single view
export default defineComponent({
  name: "match_detail",
  setup() {
    const hasLoaded = ref(false);
    const componentName = ref("");
    const matchId = ref<any>("");
    const sportType = ref<any>("football");
    const apiLiveUrl = ref<any>("");
    const siteName = ref<any>("xoilacz");
    const height = ref<number>(657);
    const isFetchOdd = ref(false);
    const myComponents: any = {
      Home: defineAsyncComponent(
        () =>
          import(
            /* webpackChunkName: 'Home' */
            "./Home.vue"
          )
      ),
      HomeBasketball: defineAsyncComponent(
        () =>
          import(
            /* webpackChunkName: 'HomeBasketball' */
            "./HomeBasketball.vue"
          )
      ),
    };

    const comp = computed(() => {
      // compare two objects
      return myComponents[componentName.value];
    });

    return {
      comp,
      componentName,
      hasLoaded,
      matchId,
      apiLiveUrl,
      sportType,
      siteName,
      height,
      isFetchOdd
    };
  },
  mounted() {
    const that = this;

    // @ts-ignore
    if (that.$win.plugin_config_match_detail) {
      that.doLoad();
      return;
    }

    document.onreadystatechange = async () => {
      if (document.readyState == "complete") {
        that.doLoad();
      }
    };
  },
  methods: {
    async doLoad() {
      await nextTick();

      const commonStore = usecommonStore();
      const matchDetailStore = useMatchDetailStore();

      // @ts-ignore
      let matchId = this.$win.plugin_config_match_detail.matchId;
      if (!matchId) {
        matchId = this.$route.query.matchId;
      }
      this.matchId = matchId ? matchId : "";

      // @ts-ignore
      let apiLiveUrl = this.$win.plugin_config_match_detail.apiLiveUrl;
      if (!apiLiveUrl) {
        apiLiveUrl = this.$route.query.apiLiveUrl;
      }
      this.apiLiveUrl = apiLiveUrl ? apiLiveUrl : "";

      // @ts-ignore
      let sportType = this.$win.plugin_config_match_detail.sportType;
      if (!sportType) {
        sportType = this.$route.query.sportType;
      }
      this.sportType = sportType ? sportType : "football";
      commonStore.setSportType(this.sportType);

      // @ts-ignore
      let siteName = this.$win.plugin_config_match_detail.siteName;
      if (!siteName) {
        siteName = this.$route.query.siteName;
      }
      this.siteName = siteName ? siteName : "xoilacz";
      commonStore.setSiteName(this.siteName);

      // @ts-ignore
      let isFetchOdd = this.$win.plugin_config_match_detail.isFetchOdd;
      if (isFetchOdd === undefined) {
        const queryValue = this.$route.query.isFetchOdd;
        const queryValueIsEmpty = queryValue === undefined || queryValue === "";
        isFetchOdd = queryValueIsEmpty ? "true" : String(queryValue);
      }
      this.isFetchOdd = isFetchOdd === "true";
      commonStore.setIsFetchOdd(this.isFetchOdd);

      // @ts-ignore
      // let viewComponent = this.$win.plugin_config_match_detail.viewComponent;
      // if (!viewComponent) {
      //   viewComponent = this.$route.query.comp;
      // }
      // if (!viewComponent) {
      //   viewComponent = "Home";
      // }

      let viewComponent = 'Home';
      this.componentName = viewComponent;

      // @ts-ignore
      let height = this.$win.plugin_config_match_detail.height;
      if (!height) {
        height = this.$route.query.height;
      }
      this.height = height ? height : 657;
      matchDetailStore.setScreenHeight(this.height);

      // make sure data is loaded before ui render
      this.hasLoaded = true;
      this.$forceUpdate();
    },
  },
});
</script>

<style scoped></style>
